import { WayfindingJob, WayfindingPlay } from './wayfinding.models';

/** Live-screen shortcuts. Paths must already exist in app.routes.ts. */
export const WAYFINDING_JOBS: WayfindingJob[] = [
  {
    id: 'job-sales-orders',
    titleKey: 'wayfinding.jobs.salesOrders.title',
    descriptionKey: 'wayfinding.jobs.salesOrders.description',
    synonyms: ['سفارش', 'فروش', 'sales order', 'order', 'ثبت سفارش'],
    route: '/sales/orders',
    moduleKey: 'universal-sales'
  },
  {
    id: 'job-quotes',
    titleKey: 'wayfinding.jobs.quotes.title',
    descriptionKey: 'wayfinding.jobs.quotes.description',
    synonyms: ['پیش فاکتور', 'پیشفاکتور', 'پروفرما', 'proforma', 'quote', 'sales quote'],
    route: '/sales/quotes',
    moduleKey: 'universal-sales'
  },
  {
    id: 'job-catalog-offerings',
    titleKey: 'wayfinding.jobs.offerings.title',
    descriptionKey: 'wayfinding.jobs.offerings.description',
    synonyms: ['محصول', 'کاتالوگ', 'offering', 'catalog', 'کالا'],
    route: '/catalog/products',
    moduleKey: 'catalog'
  },
  {
    id: 'job-parties',
    titleKey: 'wayfinding.jobs.parties.title',
    descriptionKey: 'wayfinding.jobs.parties.description',
    synonyms: ['طرف حساب', 'مشتری', 'party', 'customer', 'شخص', 'ثبت شرکت'],
    route: '/platform/parties',
    moduleKey: 'party-hub-parties'
  },
  {
    id: 'job-leads',
    titleKey: 'wayfinding.jobs.leads.title',
    descriptionKey: 'wayfinding.jobs.leads.description',
    synonyms: ['سرنخ', 'لید', 'توی لید', 'lead', 'crm', 'فرصت فروش', 'ثبت لید'],
    route: '/growth/crm/leads',
    moduleKey: 'growth'
  },
  {
    id: 'job-invoices',
    titleKey: 'wayfinding.jobs.invoices.title',
    descriptionKey: 'wayfinding.jobs.invoices.description',
    synonyms: ['فاکتور فروش', 'صورتحساب', 'invoice', 'فاکتور'],
    route: '/financial/sales/invoices',
    moduleKey: 'financial-core-ufc'
  },
  {
    id: 'job-receipts',
    titleKey: 'wayfinding.jobs.receipts.title',
    descriptionKey: 'wayfinding.jobs.receipts.description',
    synonyms: ['رسید', 'پرداخت', 'وصول', 'receipt', 'payment', 'دریافت پول'],
    route: '/financial/payments/receipts',
    moduleKey: 'financial-core-ufc'
  },
  {
    id: 'job-tasks',
    titleKey: 'wayfinding.jobs.tasks.title',
    descriptionKey: 'wayfinding.jobs.tasks.description',
    synonyms: ['وظیفه', 'کارتابل', 'task', 'inbox', 'تأیید'],
    route: '/workflow/tasks',
    moduleKey: 'workflow-bpms'
  },
  {
    id: 'job-intents',
    titleKey: 'wayfinding.jobs.intents.title',
    descriptionKey: 'wayfinding.jobs.intents.description',
    synonyms: ['فرمان کار', 'نیت', 'intent', 'شروع فرآیند'],
    route: '/workflow/intents/new',
    moduleKey: 'workflow-bpms'
  },
  {
    id: 'job-policies',
    titleKey: 'wayfinding.jobs.policies.title',
    descriptionKey: 'wayfinding.jobs.policies.description',
    synonyms: ['بیمه نامه', 'بیمه‌نامه', 'policy', 'insurance'],
    route: '/insurance/policies',
    moduleKey: 'insurance'
  },
  {
    id: 'job-journal',
    titleKey: 'wayfinding.jobs.journal.title',
    descriptionKey: 'wayfinding.jobs.journal.description',
    synonyms: ['سند حسابداری', 'journal', 'دفتر روزنامه'],
    route: '/financial/management/journal-entry',
    moduleKey: 'financial-core-ufc'
  },
  {
    id: 'job-content-assets',
    titleKey: 'wayfinding.jobs.contentAssets.title',
    descriptionKey: 'wayfinding.jobs.contentAssets.description',
    synonyms: [
      'دارایی محتوا', 'دارایی‌های محتوا', 'content asset', 'ایجاد محتوا',
      'ایجاد مقاله', 'مقاله جدید', 'کمک هوش مصنوعی', 'ai assist'
    ],
    route: '/growth/marketing/content-assets/new',
    moduleKey: 'growth'
  },
  {
    id: 'job-ace-brief',
    titleKey: 'wayfinding.jobs.aceBrief.title',
    descriptionKey: 'wayfinding.jobs.aceBrief.description',
    synonyms: [
      'بریف', 'بریف جدید', 'ایجاد بریف', 'brief', 'new brief', 'ace brief'
    ],
    route: '/growth/marketing/ace-studio/briefs/new',
    moduleKey: 'growth'
  },
  {
    id: 'job-ace-studio',
    titleKey: 'wayfinding.jobs.aceStudio.title',
    descriptionKey: 'wayfinding.jobs.aceStudio.description',
    synonyms: [
      'ace', 'استودیو محتوا', 'استودیوی محتوا', 'تولید محتوا', 'ace studio',
      'تولید از بریف', 'produce brief'
    ],
    route: '/growth/marketing/ace-studio',
    moduleKey: 'growth'
  },
  {
    id: 'job-article-publishing',
    titleKey: 'wayfinding.jobs.articlePublishing.title',
    descriptionKey: 'wayfinding.jobs.articlePublishing.description',
    synonyms: [
      'مقاله', 'انتشار مقاله', 'مقاله وبسایت', 'وبسایت', 'article', 'blog',
      'بازبینی و تایید محتوا', 'تایید محتوا'
    ],
    route: '/growth/marketing/article-publishing',
    moduleKey: 'growth'
  },
  {
    id: 'job-publish-operations',
    titleKey: 'wayfinding.jobs.publishOperations.title',
    descriptionKey: 'wayfinding.jobs.publishOperations.description',
    synonyms: ['عملیات انتشار', 'انتشار', 'publish operations', 'publish job'],
    route: '/growth/marketing/publish-operations',
    moduleKey: 'growth'
  }
];

/**
 * Multi-screen operations. Prefer these over a single job when the user
 * describes a sequence. workflowRoute / intentKey point at existing BPMS/UIO.
 */
export const WAYFINDING_PLAYS: WayfindingPlay[] = [
  {
    id: 'play-lead-to-cash',
    titleKey: 'wayfinding.plays.leadToCash.title',
    descriptionKey: 'wayfinding.plays.leadToCash.description',
    synonyms: [
      'لید', 'سرنخ', 'پیش فاکتور', 'فاکتور', 'پرداخت',
      'lead', 'proforma', 'invoice', 'receipt', 'lead to cash',
      'ثبت لید و پیش فاکتور و فاکتور'
    ],
    steps: [
      { route: '/growth/crm/leads', titleKey: 'wayfinding.plays.leadToCash.s1', whyKey: 'wayfinding.plays.leadToCash.s1why' },
      { route: '/sales/quotes', titleKey: 'wayfinding.plays.leadToCash.s2', whyKey: 'wayfinding.plays.leadToCash.s2why' },
      { route: '/financial/sales/invoices', titleKey: 'wayfinding.plays.leadToCash.s3', whyKey: 'wayfinding.plays.leadToCash.s3why' },
      { route: '/financial/payments/receipts', titleKey: 'wayfinding.plays.leadToCash.s4', whyKey: 'wayfinding.plays.leadToCash.s4why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-ai-article',
    titleKey: 'wayfinding.plays.aiArticle.title',
    descriptionKey: 'wayfinding.plays.aiArticle.description',
    synonyms: [
      'مقاله', 'وبسایت', 'انتشار مقاله', 'دارایی محتوا',
      'article', 'blog', 'website article', 'ایجاد مقاله', 'مقاله وبسایت'
    ],
    steps: [
      { route: '/growth/marketing/content-assets/new', titleKey: 'wayfinding.plays.aiArticle.s1', whyKey: 'wayfinding.plays.aiArticle.s1why' },
      { route: '/growth/marketing/article-publishing', titleKey: 'wayfinding.plays.aiArticle.s2', whyKey: 'wayfinding.plays.aiArticle.s2why' },
      { route: '/growth/marketing/publish-operations', titleKey: 'wayfinding.plays.aiArticle.s3', whyKey: 'wayfinding.plays.aiArticle.s3why' },
      { route: '/growth/marketing/content-calendar', titleKey: 'wayfinding.plays.aiArticle.s4', whyKey: 'wayfinding.plays.aiArticle.s4why', optional: true },
      { route: '/growth/marketing/approval-queue', titleKey: 'wayfinding.plays.aiArticle.s5', whyKey: 'wayfinding.plays.aiArticle.s5why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-ace-article',
    titleKey: 'wayfinding.plays.aceArticle.title',
    descriptionKey: 'wayfinding.plays.aceArticle.description',
    synonyms: [
      'ace', 'بریف', 'استودیو محتوا', 'استودیوی محتوا', 'تولید از بریف',
      'مقاله از بریف', 'ace studio', 'produce brief', 'content brief'
    ],
    steps: [
      { route: '/growth/marketing/ace-studio/briefs/new', titleKey: 'wayfinding.plays.aceArticle.s1', whyKey: 'wayfinding.plays.aceArticle.s1why' },
      { route: '/growth/marketing/ace-studio', titleKey: 'wayfinding.plays.aceArticle.s2', whyKey: 'wayfinding.plays.aceArticle.s2why' },
      { route: '/growth/marketing/article-publishing', titleKey: 'wayfinding.plays.aceArticle.s3', whyKey: 'wayfinding.plays.aceArticle.s3why' },
      { route: '/growth/marketing/publish-operations', titleKey: 'wayfinding.plays.aceArticle.s4', whyKey: 'wayfinding.plays.aceArticle.s4why' },
      { route: '/growth/marketing/content-calendar', titleKey: 'wayfinding.plays.aceArticle.s5', whyKey: 'wayfinding.plays.aceArticle.s5why', optional: true },
      { route: '/growth/marketing/approval-queue', titleKey: 'wayfinding.plays.aceArticle.s6', whyKey: 'wayfinding.plays.aceArticle.s6why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-sell-and-collect',
    titleKey: 'wayfinding.plays.sellAndCollect.title',
    descriptionKey: 'wayfinding.plays.sellAndCollect.description',
    synonyms: [
      'فروش', 'سفارش', 'فاکتور', 'رسید', 'وصول',
      'sell', 'order', 'invoice', 'receipt', 'quote to cash',
      'ثبت سفارش و دریافت پول', 'فروش تا رسید'
    ],
    steps: [
      { route: '/catalog/products', titleKey: 'wayfinding.plays.sellAndCollect.s1', whyKey: 'wayfinding.plays.sellAndCollect.s1why' },
      { route: '/sales/orders', titleKey: 'wayfinding.plays.sellAndCollect.s2', whyKey: 'wayfinding.plays.sellAndCollect.s2why' },
      { route: '/financial/sales/invoices', titleKey: 'wayfinding.plays.sellAndCollect.s3', whyKey: 'wayfinding.plays.sellAndCollect.s3why' },
      { route: '/financial/payments/receipts', titleKey: 'wayfinding.plays.sellAndCollect.s4', whyKey: 'wayfinding.plays.sellAndCollect.s4why' }
    ],
    intentKey: 'workflow.process.start',
    workflowRoute: '/workflow/definitions'
  },
  {
    id: 'play-onboard-party',
    titleKey: 'wayfinding.plays.onboardParty.title',
    descriptionKey: 'wayfinding.plays.onboardParty.description',
    synonyms: [
      'مشتری جدید', 'ثبت مشتری', 'طرف حساب', 'کاربر',
      'onboard', 'new customer', 'party', 'create customer'
    ],
    steps: [
      { route: '/platform/parties', titleKey: 'wayfinding.plays.onboardParty.s1', whyKey: 'wayfinding.plays.onboardParty.s1why' },
      { route: '/growth/crm/customer-360', titleKey: 'wayfinding.plays.onboardParty.s2', whyKey: 'wayfinding.plays.onboardParty.s2why' },
      { route: '/identity/users', titleKey: 'wayfinding.plays.onboardParty.s3', whyKey: 'wayfinding.plays.onboardParty.s3why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-issue-policy',
    titleKey: 'wayfinding.plays.issuePolicy.title',
    descriptionKey: 'wayfinding.plays.issuePolicy.description',
    synonyms: [
      'صدور بیمه', 'بیمه نامه', 'نرخ', 'استعلام', 'پذیرش ریسک',
      'issue policy', 'quote', 'underwriting', 'bind'
    ],
    steps: [
      { route: '/insurance/products', titleKey: 'wayfinding.plays.issuePolicy.s1', whyKey: 'wayfinding.plays.issuePolicy.s1why' },
      { route: '/insurance/quotes', titleKey: 'wayfinding.plays.issuePolicy.s2', whyKey: 'wayfinding.plays.issuePolicy.s2why' },
      { route: '/insurance/uw-cases', titleKey: 'wayfinding.plays.issuePolicy.s3', whyKey: 'wayfinding.plays.issuePolicy.s3why' },
      { route: '/insurance/policies', titleKey: 'wayfinding.plays.issuePolicy.s4', whyKey: 'wayfinding.plays.issuePolicy.s4why' }
    ],
    intentKey: 'workflow.process.start',
    workflowRoute: '/workflow/definitions'
  },
  {
    id: 'play-grow-lead',
    titleKey: 'wayfinding.plays.growLead.title',
    descriptionKey: 'wayfinding.plays.growLead.description',
    synonyms: [
      'کمپین', 'سرنخ', 'بازاریابی', 'رشد',
      'campaign', 'lead', 'marketing', 'nurture'
    ],
    steps: [
      { route: '/growth/crm/leads', titleKey: 'wayfinding.plays.growLead.s1', whyKey: 'wayfinding.plays.growLead.s1why' },
      { route: '/growth/marketing/campaigns', titleKey: 'wayfinding.plays.growLead.s2', whyKey: 'wayfinding.plays.growLead.s2why' },
      { route: '/growth/concierge', titleKey: 'wayfinding.plays.growLead.s3', whyKey: 'wayfinding.plays.growLead.s3why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-approve-work',
    titleKey: 'wayfinding.plays.approveWork.title',
    descriptionKey: 'wayfinding.plays.approveWork.description',
    synonyms: [
      'تأیید', 'کارتابل', 'گردش کار', 'فرمان کار', 'نیت', 'وظیفه',
      'approve', 'inbox', 'workflow', 'intent', 'task'
    ],
    steps: [
      { route: '/workflow/tasks', titleKey: 'wayfinding.plays.approveWork.s1', whyKey: 'wayfinding.plays.approveWork.s1why' },
      { route: '/workflow/intents/approvals/inbox', titleKey: 'wayfinding.plays.approveWork.s2', whyKey: 'wayfinding.plays.approveWork.s2why' },
      { route: '/workflow/intents/new', titleKey: 'wayfinding.plays.approveWork.s3', whyKey: 'wayfinding.plays.approveWork.s3why' }
    ],
    intentKey: 'workflow.process.start',
    workflowRoute: '/workflow/intents/new'
  }
];
